import React, { useEffect, useMemo } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

import { ContentWrapper } from 'components/ContentWrapper';
import { Footer } from 'components/Footer';
import { Header } from 'components/Header';
import { ScrollToTop } from 'components/ScrollToTop';
import { Sidebar } from 'components/Sidebar';
import { useChain, usePrice } from 'contexts';
import { GlobalStats, HomePage, LoadingPage, PolygonTreasury, Portfolio } from './pages';

const AppContent = () => {
  const { isInitialized: priceInit } = usePrice();
  const { isInitialized: chainInit } = useChain();
  const isLoading = useMemo(() => !priceInit || !chainInit, [priceInit, chainInit]);

  useEffect(() => {
    const body = window.document.getElementsByTagName('body')[0];
    if (isLoading) {
      body.classList.add('overflow-hidden');
    } else {
      body.classList.remove('overflow-hidden');
    }
  }, [isLoading]);

  return (
    <Router>
      <ScrollToTop />
      {isLoading && <LoadingPage />}
      <Header />
      <ContentWrapper>
        <Sidebar />
        <div className="flex-grow border-t-2 border-sand-light dark:border-gray-222">
          <div className="p-5 pt-10">
            <Switch>
              <Route path="/stats">
                <GlobalStats />
              </Route>
              <Route path="/portfolio">
                <Portfolio />
              </Route>
              <Route path="/polygon-treasury">
                <PolygonTreasury />
              </Route>
              <Route path="/dapps">dApps</Route>
              <Route path="/resources">Resources</Route>
              <Route path="/" exact>
                <HomePage />
              </Route>
            </Switch>
          </div>
          <Footer />
        </div>
      </ContentWrapper>
    </Router>
  );
};

export default AppContent;
